export const buildAuthHref = (href: string, next?: string) => {
    const isAbsoluteUrl = href.startsWith('http://') || href.startsWith('https://')
    const url = new URL(href, isAbsoluteUrl ? undefined : 'https://giphy.test')

    if (next) {
        url.searchParams.set('next', next)
    }

    if (isAbsoluteUrl) {
        return url.toString()
    }

    return `${url.pathname}${url.search}${url.hash}`
}
